<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" field-name="학교명" :board="this.board" :is-print="isPrint" />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 위험성평가 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>공정명(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" :readonly="board.readonly" />
        </div>
<!--        <div>-->
<!--          <div>작업내용(필수)</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>-->
<!--          <ml-input v-else v-model="form.inputB_3" :readonly="board.readonly" />-->
<!--        </div>-->
        <div>
          <div>평가일(필수)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <date-selector v-else v-model="form.inputB_4" :readonly="board.readonly" />
        </div>
<!--        <div>-->
<!--          <div>대상기간</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }} ~ {{ form.inputB_9 }}</p>-->
<!--          <div v-else class="time">-->
<!--            <date-selector v-model="form.inputB_8" :readonly="board.readonly" @change="checkDate(form.inputB_8)" />-->
<!--            ~-->
<!--            <date-selector v-model="form.inputB_9" :readonly="board.readonly" @change="checkDate(form.inputB_9)" />-->
<!--          </div>-->
<!--        </div>-->
        <div>
          <div>예정공정표 첨부</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputB_10.fileName }}
          </p>
          <file-uploader :readonly="board.readonly" v-else v-model="form.inputB_10" />
        </div>
      </div>
    </div>

    <!--    위험성 평가표-->
    <table-risk-appraisal-ep_3x3 class="mt-5" title="위험성평가표" :value="form.riskAppraisalList" @input="updateList" :isPrint="isPrint" :readonly="board.readonly" :hide-code-number="true" />

    <!-- 안전·보건관리자 검토의견 -->
    <table-risk-appraisal-ep2_3x3 class="mt-5" title="검토의견" v-model="form.riskAppraisalList2" :isPrint="isPrint" :readonly="board.readonly" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import TableRiskAppraisalEp from "@/components/TableRiskAppraisalEp.vue";
import TableRiskAppraisalEp2 from "@/components/TableRiskAppraisalEp2.vue";
import { required } from "vuelidate/lib/validators";
import TableRiskAppraisalEp_3x3 from "@/components/TableRiskAppraisalEp_3x3.vue";
import TableRiskAppraisalEp2_3x3 from "@/components/TableRiskAppraisalEp2_3x3.vue";

export default {
  components: {
    TableRiskAppraisalEp2_3x3,
    TableRiskAppraisalEp_3x3,
    DateSelector,
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
    TableRiskAppraisalEp,
    TableRiskAppraisalEp2,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
      inputB_2: { required },
      inputB_4: { required },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    form: {
      important: false,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.form.summary = {
          정기위험성평가_사업장명: [],
          정기위험성평가_재해형태: [],
        };

        this.form.summary["정기위험성평가_사업장명"].push({
          [this.form.stdInfo.field_name]: 1,
        });

        for (const data of this.form.riskAppraisalList) {
          this.form.summary["정기위험성평가_재해형태"].push({
            [data.input_3]: 1,
          });
        }

        this.$emit("input", this.form);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",
        inputB_10: {}, // file

        photoList: [],
        photoListAfter: [],
        fileList: [],
        riskAppraisalList: [],
        riskAppraisalList2: [],
        disasters: "",
      },
    };
  },
  methods: {
    updateList(list) {
      this.form.riskAppraisalList = list;

      this.form.disasters = "";
      for (const risk of this.form.riskAppraisalList) {
        this.form.disasters += `${risk.input_3} `;
      }
    },
    checkDate(input) {
      if (Date.parse(this.form.inputB_8) > Date.parse(this.form.inputB_9)) {
        if (input === this.form.inputB_8) {
          this.form.inputB_9 = this.form.inputB_8;
        } else {
          this.form.inputB_8 = this.form.inputB_9;
        }
      }
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.inputB_2.required) return "공정명을 반드시 입력해야 합니다";
        else if (!this.$v.form.inputB_4.required) return "평가일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
